import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OverviewComponent } from './overview/overview.component';
import { LicenseComponent } from './license/license.component';
import { SamplesComponent } from './samples/samples.component';
import { ReferenceComponent } from './reference/reference.component';
import { ReleaseComponent } from './release/release.component';

const routes: Routes = [
	{
		path: '',
		component: OverviewComponent
	},
    {
        path: 'overview',
        component: OverviewComponent
    },
    {
        path: 'release',
        component: ReleaseComponent
    },
    {
        path: 'license',
        component: LicenseComponent
    },
    {
        path: 'samples',
        component: SamplesComponent
    },
    {
        path: 'reference',
        component: ReferenceComponent
	},
	{
		path: '**',
		component: OverviewComponent
	}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }